<div id="group-id-{{_data.id}}" class="day">
    <div class="day__header">
        <div class="row">
            <button 
                (click)="onToggleContentVisible()"
                [ngClass]="{'is-visible': isVisibleContent}"
                class="day__header__toggle-btn"
            >
                <i class="pi pi-angle-up"></i>
            </button>

            <div class="column">
                <span class="day__header__title-day">
                    {{ _data.date | date: 'EEEE' : '' : langauge }}
                </span>
                <span class="day__header__date">
                    {{ _data.date | date: 'd.MM.yyyy' : '' : langauge }}
                </span>
            </div>
        </div>
        <div class="right row">
            <div class="day__header__summary">
                <i class="pi pi-map-marker icon"></i>
                <span class="day__header__summary__title">{{totalDistance | distance}}</span>
            </div>
            <div class="day__header__summary">
                <i class="pi pi-angle-up icon"></i>
                <span class="day__header__summary__title">
                    {{totalMinutes}}
                </span>
            </div>
            <div class="day__header__summary">
                <i class="pi pi-flag icon"></i>
                <span class="day__header__summary__title">
                    {{stopTime}}
                </span>
            </div>
        </div>
    </div>

    <div class="day__timeline">
        <app-report-route-day-timeline [data]="timelineData"></app-report-route-day-timeline>
    </div>

    <div *ngIf="isVisibleContent" class="day__routes">
        <app-route-part
            *ngFor="let item of timelineData.routes; let index = index; trackBy: trackByRoute"
            (click)="onSelectRoute(item, index)"
            [data]="item"
            [index]="index"
            [isSelected]="selectedRoute?.Id === item.Id"
        ></app-route-part>
    </div>
</div>
